import React from 'react';


export default class ItemSelection extends React.Component {
  constructor(props) {
    super(props);
    this.option = this.option.bind(this);
  }
 
  option() {
    let optionArray = [];
    const d = this.props.data;
    const data = d[d['detail']['type']];
    let i = 1;
    let num = Object.keys(data).length
    
    for (let j = 0; j < num; j++) { //** let fileID in data //let j = 0; j < Object.keys(data).length; j++
      let fileID = Object.keys(data)[j];
      optionArray.push(
        <option key={ fileID } value={ fileID }>{i}. {data[fileID]['itemName']}</option>
      );
      i++;
    }

    return optionArray;
  }

  render() {
    return (
      <div id="item-selection">
        <h2>{ this.props.typeChsName }類農作物選擇</h2>
        <select name="items" onChange={(event) => {this.props.onChange(event.target.value)}}>
          <option defaultValue value='-'>-- 請選擇{this.props.typeChsName} --</option>
          { this.option() }
        </select>
      </div>
    );
  }
};


// WEBPACK FOOTER //
// ./src/components/containers/selection.js